import React from 'react'
import DragIndicator from '@material-ui/icons/DragIndicator'
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc'

export const SortableContainer = sortableContainer(({ children }) => {
	return <div>{children}</div>
})
export const SortableItem = sortableElement(({ children }) => <>{children}</>)
export const DragHandle = sortableHandle((props) => <DragIndicator {...props} />)
